/* eslint-disable vue/require-v-for-key */
<template>
  <v-card>
    <v-form ref="form" v-model="isFormValid" lazy-validation>
      <v-card-text>
        <v-container>
          <!-- <v-row>
            <v-select
              v-if="selectedIndex !== -1"
              v-model="selectedItem.lotes"
              :items="lotes"
              item-text="lote"
              item-value="id"
              label="Lotes"
              v-on:change="changeTokens(selectedItem.lotes)"
            ></v-select>
          </v-row>
          <v-row>
            <v-expansion-panels accordion v-if="selectedIndex !== -1">
              <v-expansion-panel>
                <v-expansion-panel-header
                  >Tokens ({{ tokens.length }})</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <ul id="tokens">
                    <li v-for="token in tokens" :key="token">
                      {{ token }}
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row> -->
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h4>Informações do ativo</h4>
              <v-text-field
                v-model="selectedItem.nameToken"
                label="Nome do Token"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                v-model="selectedItem.description"
                :counter="250"
                :rules="formRules.descriptionRules"
                label="Descrição Completa"
                required
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h4>Categorias do ativo</h4>
              <v-select
                v-model="selectedItem.category"
                :items="categories"
                item-text="category"
                item-value="id"
                label="Categoria"
                persistent-hint
                return-object
                single-line
                multiple
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="selectedItem.subcategories"
                :items="subcategoriesList"
                item-text="subcategory"
                item-value="id"
                label="Subcategorias / Tags"
                persistent-hint
                return-object
                single-line
                chips
                multiple
              ></v-select>
            </v-col>
          </v-row>
          <!-- vvvvvv PRECISA TESTAR SE ESSA TROCA FUNCIONA vvvvvv -->
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-file-input
                v-if="
                  selectedItem.category &&
                  selectedItem.category.some((item) => item.adoption)
                "
                v-model="selectedItem.kmz"
                hide-details="auto"
                label="Arquivo georeferenciado"
                prepend-icon="mdi-file-code"
                show-size
                small-chips
              ></v-file-input>
            </v-col>
          </v-row>
          <!-- ^^^^^ PRECISA TESTAR SE ESSA TROCA FUNCIONA ^^^^^ -->
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <h4>Unidade de medida do ativo</h4>
              <v-select
                v-model="selectedItem.unidades"
                :items="unidades"
                item-text="unid"
                item-value="id"
                label="Unidade de medida do token"
                return-object
              ></v-select>
            </v-col>

            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-if="
                  selectedItem.unidades
                    ? selectedItem.unidades.id == 7 ||
                      selectedItem.unidades == 'Outros'
                      ? true
                      : false
                    : false
                "
                v-model="selectedItem.otherUnid"
                label="Outros"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.complement"
                label="Complemento"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-if="selectedItem.unidades"
                v-model="selectedItem.valorunidade"
                :label="
                  'Qtde de cada unidade ( ' + selectedItem.unidades.unid + ' )'
                "
                required
                hide-details="auto"
                :disabled="
                  selectedItem.category
                    ? selectedItem.category.some(({ adoption }) => adoption)
                    : false
                "
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h4>Fotos do ativo</h4>
              <v-file-input
                v-model="selectedItem.photo"
                hide-details="auto"
                label="Logo do Token disponível para visualização dos Usuários"
                prepend-icon="mdi-camera"
                accept="image/*"
                show-size
                small-chips
                @change="selectedNewLogoToken"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-file-input
                v-model="selectedItem.files"
                hide-details="auto"
                label="Arquivos disponíveis para visualização dos Usuários"
                prepend-icon="mdi-camera"
                multiple
                show-size
                counter
                small-chips
                truncate-length="25"
              ></v-file-input>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <table
                v-for="(file, index) in filesActives"
                :key="file.id"
                :style="{ marginBottom: '20px' }"
              >
                <tr>
                  <th>Visualizar</th>
                  <th>Excluir</th>
                </tr>
                <tr>
                  <td
                    :style="{ width: '206px !important', textAlign: 'center' }"
                  >
                    <a
                      :href="
                        'https://filesgpx.s3.us-east-2.amazonaws.com/' +
                        file.path
                      "
                      download
                      target="_blank"
                    >
                      {{ file.name }}
                    </a>
                  </td>
                  <td>
                    <v-row
                      align="center"
                      justify="center"
                      :style="{ cursor: 'pointer' }"
                      @click="deleteFile(index, file.path)"
                    >
                      <v-icon color="red"> mdi-delete </v-icon>
                    </v-row>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h4>Índice de referência de valor</h4>
              <v-text-field
                v-model="selectedItem.apiIndex"
                label="API índice"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h4>Data limite</h4>
              <v-text-field
                v-model="selectedItem.deadlineToken"
                label="Data limite"
                :rules="formRules.dataRules"
                type="date"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h4>Preço de negociação</h4>
              <v-select
                v-model.lazy="typeValue"
                :items="itemsValueType"
                item-text="type"
                item-value="id"
                label="Tipo do valor"
                persistent-hint
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row v-if="fixedValue">
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.singleValue"
                label="Valor único"
                required
                hide-details="auto"
                prefix="R$"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <div v-if="variableValue">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="selectedItem.minValueToken"
                  label="Valor minimo por Token"
                  required
                  hide-details="auto"
                  prefix="R$"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="selectedItem.totalValueToken"
                  label="Valor total do ativo"
                  required
                  hide-details="auto"
                  prefix="R$"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h4>
                Limite de quantidade de tokens emitidos (trava a emissão de
                tokens acima da quantidade informada)
              </h4>
              <v-checkbox
                v-model="checkbox"
                :label="`Limitar Ativo por Quantidade máxima de tokens?`"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row v-if="checkbox">
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.amountToken"
                label="Quantidade máxima de tokens"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h4>Configurações de criptoativo (BTC, ETH, ADA, etc)</h4>
              <v-select
                v-model="selectedItem.cryptoactive"
                :items="itemsCryptoactive"
                item-text="type"
                item-value="bool"
                label="É um criptoativo?"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h4>Configurações de certificado</h4>
              <v-select
                v-model="selectedItem.certificate"
                :items="itemsCertificate"
                item-text="type"
                item-value="bool"
                label="Emite certificado?"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row
            v-if="selectedItem.certificate ? selectedItem.certificate.bool : ''"
          >
            <v-col cols="12" sm="12" md="12">
              <h4>Campos do certificado</h4>
              <v-text-field
                label="Título do Certificado*"
                v-model="selectedItem.certificate_title"
                :rules="formRules.certificate_title"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="Subtítulo do certificado*"
                v-model="selectedItem.certificate_subtitle"
                :rules="formRules.certificate_subtitle"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                v-model="selectedItem.certificate_description"
                :counter="500"
                :rules="formRules.certificate_description"
                label="Descrição Completa"
                required
                hide-details="auto"
              ></v-textarea>
              <p>
                Dica de utilização da descrição: Utilize as variáveis
                <b>{ano}</b> e <b>{quantidade}</b> no meio do texto e a
                quantidade emitida e o ano de emissão do certificado emitido
                irão ser posicionados nos locais dessas variáveis. Exemplo de
                texto: "Foram emitidos {quantidade} tokens referente ao ano de
                {ano}."
              </p>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="Rodapé do certificado*"
                v-model="selectedItem.certificate_footer"
                :rules="formRules.certificate_footer"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-file-input
                label="Marca d'água do certificado*"
                v-model="selectedItem.certificate_watermark"
                :rules="formRules.certificate_watermark"
                required
                hide-details="auto"
              ></v-file-input>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-file-input
                label="Background do certificado*"
                v-model="selectedItem.certificate_background"
                :rules="formRules.certificate_background"
                required
                hide-details="auto"
              ></v-file-input>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="Texto da questão de quantidade no formulário de pré-emissão"
                v-model="selectedItem.certificate_question_amount"
                :rules="formRules.certificate_question_amount"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="selectedItem.certificate_question_year"
                :items="itemsCertificate"
                item-text="type"
                item-value="bool"
                label="Perguntar o ano no formulário de pré-emissao?"
                return-object
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="selectedItem.certificate_ods"
                :items="[
                  { id: 1, text: '1 - Erradicação da Pobreza' },
                  { id: 2, text: '2 - Fome zero e agricultura sustentável' },
                  { id: 3, text: '3 - Saúde e bem-estar' },
                  { id: 4, text: '4 - Educação de qualidade' },
                  { id: 5, text: '5 - Igualdade de gênero' },
                  { id: 6, text: '6 - Água potável e saneamento' },
                  { id: 7, text: '7 - Energia limpa e acessível' },
                  {
                    id: 8,
                    text: '8 - Trabalho decente e crescimento econômico',
                  },
                  { id: 9, text: '9 - Indústria, inovação e ingfraestrutura' },
                  { id: 10, text: '10 - Redução das desigualdades' },
                  { id: 11, text: '11 - Cidades e comunidades sustentáveis' },
                  { id: 12, text: '12 - Consumo e produção responsáveis' },
                  {
                    id: 13,
                    text: '13 - Ação contra a mudança global do clima',
                  },
                  { id: 14, text: '14 - Vida na água' },
                  { id: 15, text: '15 - Vida terrestre' },
                  { id: 16, text: '16 - Paz, justiça e instituições eficazes' },
                  { id: 17, text: '17 - Parcerias e meios de implementação' },
                ]"
                item-text="text"
                item-value="id"
                label="ODS - Onu"
                persistent-hint
                return-object
                single-line
                chips
                multiple
              ></v-select>
            </v-col>
          </v-row>

          <v-row mb="10">
            <v-col cols="6" sm="6" md="6">
              <h4>Casas decimais (0 para ativos vendidos por unidade)</h4>
              <v-text-field
                v-model="selectedItem.feezeroMk"
                label="Número casas decimais"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="4" md="4">
              <h4>Taxas</h4>
              <v-text-field
                v-model="selectedItem.feeMk"
                label="Taxa Marketplace"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <h4>Moedas das taxas</h4>
              <v-select
                v-model="selectedItem.currencyMk"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <h4>Tipos de taxa</h4>
              <v-select
                v-model="selectedItem.typeFeeMk"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                return-object
                label="Tipo de taxa"
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeExBuy"
                label="Taxa Compra Exchange"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencyExBuy"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeExBuy"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeExShell"
                label="Taxa Venda Exchange"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencyExShell"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeExShell"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeTx"
                label="Taxa de Transferência"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencyTx"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeTx"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row
            v-if="
              typeof selectedItem.cryptoactive != 'object'
                ? selectedItem.cryptoactive
                : selectedItem.cryptoactive
                ? selectedItem.cryptoactive.bool
                : false
            "
          >
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeDp"
                label="Taxa de Depósito"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencyDp"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeDp"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>

          <v-row
            v-if="
              typeof selectedItem.cryptoactive != 'object'
                ? selectedItem.cryptoactive
                : selectedItem.cryptoactive
                ? selectedItem.cryptoactive.bool
                : false
            "
          >
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                v-model="selectedItem.feeSk"
                label="Taxa de Saque"
                required
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.currencySk"
                :items="itemsCurrency"
                item-text="type"
                item-value="bool"
                label="Moeda de Taxa"
                return-object
              ></v-select>
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-select
                v-model="selectedItem.typeFeeSk"
                :items="itemsTypefee"
                item-text="type"
                item-value="bool"
                label="Tipo de taxa"
                return-object
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#0dc4b8" text @click="$emit('onClose')"> Cancelar </v-btn>
        <v-btn
          color="#0dc4b8"
          text
          @click="submit"
          :disabled="isLoading"
          :loading="isLoading"
        >
          {{ formButtonText }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import {mapMutations} from 'vuex';
import Api from '../../services/api.service';
import ClientsService from '../../services/clients.service';

export default {
  name: 'AssetsForm',
  props: {
    selectedIndex: {
      type: Number,
      required: false,
      default: -1,
    },
    selectedData: [Array, Object],
    filesActivesProps: Array,
  },
  data: () => ({
    tokens: [],
    tokensGeral: [],
    lotes: [],
    checkbox: false,
    clientSearch: null,
    categories: [],
    clientOptions: [],
    dialog: false,
    unidades: [
      { id: 1, unid: 'ton' },
      { id: 2, unid: 'kg' },
      { id: 3, unid: 'g' },
      { id: 4, unid: 'lt' },
      { id: 5, unid: 'm2' },
      { id: 6, unid: 'Und' },
      // { id: 7, unid: "Outros" },
    ],
    itemsCryptoactive: [
      { type: 'Sim', bool: true },
      { type: 'Não', bool: false },
    ],
    itemsCertificate: [
      { type: 'Sim', bool: true },
      { type: 'Não', bool: false },
    ],
    itemsValueType: [
      { type: 'Valor Fixo', id: 1 },
      { type: 'Valor Variável', id: 2 },
    ],
    itemsCurrency: [
      { type: 'Próprio ativo', bool: true },
      { type: 'GPX', bool: false },
    ],
    itemsTypefee: [
      { type: 'Valor Fixo', bool: true },
      { type: 'Valor Variável (%)', bool: false },
    ],
    files: [],
    formRules: {
      clientRules: [(v) => !!v || 'Cliente é obrigatório'],
      codeRules: [(v) => !!v || 'Código é obrigatório'],
      dataRules: [(v) => !!v || 'Data é obrigatório'],
      descriptionRules: [
        (v) => !!v || 'Descrição é obrigatória',
        (v) =>
          (v || '').length <= 250 ||
          'A descrição deve ter 250 caracteres ou menos',
      ],
      filesRules: [
        (v) =>
          !!v || v.size < 2000000 || 'Documento deve ser menor do que 2 MB!',
      ],
      photosRules: [
        (v) => !!v || v.size < 2000000 || 'Foto deve ser menor do que 2 MB!',
      ],
      certificate_title: [(v) => !!v || 'Titulo do certificado é obrigatória'],
      certificate_subtitle: [
        (v) => !!v || 'Subtitulo do certificado  é obrigatória',
      ],
      certificate_description: [
        (v) => !!v || 'Descrição do certificado é obrigatória',
      ],
      certificate_question_amount: [
        (v) =>
          !!v || 'Definir a questão de quantidade do certificado é obrigatório',
      ],
      certificate_question_year: [
        (v) =>
          !!v || 'Definir se o ano do certificado deve aparecer é obrigatório',
      ],
      certificate_footer: [
        (v) => !!v || 'Rodapé do certificado  é obrigatória',
      ],
      certificate_watermark: [
        (v) => !!v || "Marca d'agua do certificado  é obrigatória",
      ],
      certificate_background: [
        (v) => !!v || 'Background do certificado  é obrigatória',
      ],
    },
    isFormValid: true,
    isLoading: false,
    photos: [],
    newLogoToken: 0,
    selectedItem: {
      otherUnid: null,
      complement: null,
      nameToken: null,
      description: null,
      photo: null,
      category: null,
      minValueToken: null,
      totalValueToken: null,
      singleValue: null,
      amountToken: null,
      valueType: null,
      cryptoactive: null,
      certificate: true,
      deadlineToken: null,
      lotes: 1,
      files: [],
      kmz: null,
      feeMk: null,
      feezeroMk: null,
      typeFeeMk: null,
      currencyMk: null,
      feeSk: null,
      feezeroSk: null,
      typeFeeSk: null,
      currencySk: null,
      feeTx: null,
      feezeroTx: null,
      typeFeeTx: null,
      currencyTx: null,
      feeExBuy: null,
      feezeroExBuy: null,
      typeFeeExBuy: null,
      currencyExBuy: null,
      feeExShell: null,
      feezeroExShell: null,
      typeFeeExShell: null,
      currencyExShell: null,
      feeDp: null,
      feezeroDp: null,
      typeFeeDp: null,
      currencyDp: null,
      unidades: null,
      subcategories: null,
      certificate_title: null,
      certificate_subtitle: null,
      certificate_description: null,
      certificate_footer: null,
      certificate_watermark: null,
      certificate_background: null,
      certificate_question_amount: null,
      certificate_question_year: null,
      certificate_ods: null,
    },
    fixedValue: false,
    variableValue: false,
    typeValue: null,
    filesActives: [],
    filesDelete: [],
    subcategoriesList: [],
  }),
  computed: {
    formButtonText() {
      return this.selectedIndex === -1 ? 'Criar' : 'Editar';
    },
  },
  watch: {
    clientSearch(val) {
      if (!this.selectedItem.client_id) val && this.loadClientData(val);
    },

    typeValue: function (value) {
      this.selectedItem.valueType = value.type;

      if (value.id === 1) {
        this.fixedValue = true;
        this.variableValue = false;

        this.selectedItem.minValueToken = null;
        this.selectedItem.totalValueToken = null;
      } else {
        this.fixedValue = false;
        this.variableValue = true;

        this.selectedItem.singleValue = null;
      }
    },
  },
  async mounted() {
    await this.fakeTokensGrid();
    await this.loadCategories();

    this.initializeSelectedItem();


    if (this.selectedIndex === -1) {
      await this.limpaForm();
    } else {
      await this.loadSelectedData();
    }
  },

  methods: {
    initializeSelectedItem() {
      this.selectedItem = this.selectedItem || {};
      this.selectedItem.category = this.selectedItem.category || [];
      this.selectedItem.subcategories = this.selectedItem.subcategories || [];
      this.selectedItem.nameToken = this.selectedItem.nameToken || '';
      this.selectedItem.description = this.selectedItem.description || '';
      this.selectedItem.amountToken = this.selectedItem.amountToken || 0;
      this.selectedItem.cryptoactive = this.selectedItem.cryptoactive || '';
      this.selectedItem.certificate = this.selectedItem.certificate || {
        bool: false,
      };
      this.selectedItem.deadlineToken = this.selectedItem.deadlineToken || '';
      this.selectedItem.unidades = this.selectedItem.unidades || {};
      this.selectedItem.otherUnid = this.selectedItem.otherUnid || '';
      this.selectedItem.complement = this.selectedItem.complement || '';
      this.selectedItem.valorunidade = this.selectedItem.valorunidade || 0;
      this.selectedItem.feeMk = this.selectedItem.feeMk || 0;
      this.selectedItem.currencyMk = this.selectedItem.currencyMk || '';
      this.selectedItem.typeFeeMk = this.selectedItem.typeFeeMk || '';
      this.selectedItem.feezeroMk = this.selectedItem.feezeroMk || 0;
      this.selectedItem.feeSk = this.selectedItem.feeSk || 0;
      this.selectedItem.currencySk = this.selectedItem.currencySk || '';
      this.selectedItem.typeFeeSk = this.selectedItem.typeFeeSk || '';
      this.selectedItem.feezeroSk = this.selectedItem.feezeroSk || 0;
      this.selectedItem.feeTx = this.selectedItem.feeTx || 0;
      this.selectedItem.currencyTx = this.selectedItem.currencyTx || '';
      this.selectedItem.typeFeeTx = this.selectedItem.typeFeeTx || '';
      this.selectedItem.feezeroTx = this.selectedItem.feezeroTx || 0;
      this.selectedItem.feeExBuy = this.selectedItem.feeExBuy || 0;
      this.selectedItem.currencyExBuy = this.selectedItem.currencyExBuy || '';
      this.selectedItem.typeFeeExBuy = this.selectedItem.typeFeeExBuy || '';
      this.selectedItem.feezeroExBuy = this.selectedItem.feezeroExBuy || 0;
      this.selectedItem.feeExShell = this.selectedItem.feeExShell || 0;
      this.selectedItem.currencyExShell = this.selectedItem.currencyExShell || '';
      this.selectedItem.typeFeeExShell = this.selectedItem.typeFeeExShell || '';
      this.selectedItem.feezeroExShell = this.selectedItem.feezeroExShell || 0;
      this.selectedItem.feeDp = this.selectedItem.feeDp || 0;
      this.selectedItem.currencyDp = this.selectedItem.currencyDp || '';
      this.selectedItem.typeFeeDp = this.selectedItem.typeFeeDp || '';
      this.selectedItem.feezeroDp = this.selectedItem.feezeroDp || 0;
      this.selectedItem.certificate_title =
          this.selectedItem.certificate_title || '';
      this.selectedItem.certificate_subtitle =
          this.selectedItem.certificate_subtitle || '';
      this.selectedItem.certificate_description =
          this.selectedItem.certificate_description || '';
      this.selectedItem.certificate_footer =
          this.selectedItem.certificate_footer || '';
      this.selectedItem.certificate_watermark =
          this.selectedItem.certificate_watermark || '';
      this.selectedItem.certificate_background =
          this.selectedItem.certificate_background || '';
      this.selectedItem.certificate_question_amount =
          this.selectedItem.certificate_question_amount || '';
      this.selectedItem.certificate_question_year =
          this.selectedItem.certificate_question_year || '';
      this.selectedItem.certificate_ods = this.selectedItem.certificate_ods || [];
      this.selectedItem.minValueToken = this.selectedItem.minValueToken || 0;
      this.selectedItem.totalValueToken = this.selectedItem.totalValueToken || 0;
      this.selectedItem.singleValue = this.selectedItem.singleValue || 0;
      this.selectedItem.photo = this.selectedItem.photo || null;
      this.selectedItem.files = this.selectedItem.files || [];
    },

    async processTypeValue() {
      const type = this.selectedData.type_value === 'Valor Fixo' ? 1 : 2;
      this.typeValueMounted(type);
      this.typeValue = { id: type, type: this.selectedData.type_value };

      this.fixedValue = type === 1;
      this.variableValue = type === 2;

      this.selectedItem.minValueToken = this.selectedData.min_value_token;
      this.selectedItem.totalValueToken = this.selectedData.total_value_token;
      this.selectedItem.singleValue = this.selectedData.single_value;
    },

    async loadFiles() {
      try {
        if (this.selectedData.path) {
          const photoUrl = `https://filesgpx.s3.us-east-2.amazonaws.com/${this.selectedData.path}`;
          this.selectedItem.photo = await this.loadFileFromUrl(
              photoUrl,
              this.selectedData.name,
              this.selectedData.mime_type
          );
        }

        if (this.filesActivesProps?.length) {
          const filePromises = this.filesActivesProps.map(item =>
              this.loadFileFromUrl(
                  `https://filesgpx.s3.us-east-2.amazonaws.com/${item.path}`,
                  item.name,
                  item.mime_type
              )
          );

          const loadedFiles = await Promise.all(filePromises);
          this.selectedItem.files = loadedFiles.filter(file => file !== null);
        }

        if (this.selectedItem.certificate_watermark) {
          this.selectedItem.certificate_watermark = await this.loadFileFromUrl(
              `https://filesgpx.s3.us-east-2.amazonaws.com/${this.selectedItem.certificate_watermark}`,
              'watermark.png',
              'image/png'
          );
        }

        if (this.selectedItem.certificate_background) {
          this.selectedItem.certificate_background = await this.loadFileFromUrl(
              `https://filesgpx.s3.us-east-2.amazonaws.com/${this.selectedItem.certificate_background}`,
              'background.png',
              'image/png'
          );
        }


        this.filesActives = this.filesActivesProps;
      } catch (error) {
        console.error('Erro ao carregar arquivos:', error);
      }
    },

    async loadFileFromUrl(url, fileName, mimeType) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const blob = await response.blob();
        return new File([blob], fileName, { type: mimeType });
      } catch (error) {
        console.error(`Erro ao carregar arquivo ${fileName}:`, error);
        return null;
      }
    },

    async loadSelectedData() {
      try {
        this.updateSelectedItemData();

        await this.processTypeValue();
        await this.loadFiles();
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      }
    },

    updateSelectedItemData() {
      this.selectedItem.subcategories = this.selectedData.subcategories;
      this.selectedItem.nameToken = this.selectedData.name_token;
      this.selectedItem.description = this.selectedData.description;
      this.selectedItem.amountToken = this.selectedData.amount_token;
      this.selectedItem.cryptoactive = this.selectedData.cryptoactive;
      this.selectedItem.certificate = { bool: this.selectedData.certificate };
      this.selectedItem.deadlineToken = this.selectedData.deadline_token;
      this.selectedItem.otherUnid = this.selectedData.otherUnid;
      this.selectedItem.complement = this.selectedData.complement;
      this.checkbox = this.selectedData.checkbox;
      this.selectedItem.valorunidade = this.selectedData.valorunidade;

      // Certifique-se de que 'unidades' está corretamente definido
      this.selectedItem.unidades =
          this.unidades.find(
              ({ unid }) => unid == this.selectedData.unidades
          ) || {};

      // Atribuições relacionadas a taxas (fees)
      this.selectedItem.feeMk = this.selectedData.feeMk;
      this.selectedItem.currencyMk = this.selectedData.currencyMk;
      this.selectedItem.typeFeeMk = this.selectedData.typeFeeMk;
      this.selectedItem.feezeroMk = this.selectedData.feezeroMk;
      this.selectedItem.feeSk = this.selectedData.feeSk;
      this.selectedItem.currencySk = this.selectedData.currencySk;
      this.selectedItem.typeFeeSk = this.selectedData.typeFeeSk;
      this.selectedItem.feezeroSk = this.selectedData.feezeroSk;
      this.selectedItem.feeTx = this.selectedData.feeTx;
      this.selectedItem.currencyTx = this.selectedData.currencyTx;
      this.selectedItem.typeFeeTx = this.selectedData.typeFeeTx;
      this.selectedItem.feezeroTx = this.selectedData.feezeroTx;
      this.selectedItem.feeExBuy = this.selectedData.feeExBuy;
      this.selectedItem.currencyExBuy = this.selectedData.currencyExBuy;
      this.selectedItem.typeFeeExBuy = this.selectedData.typeFeeExBuy;
      this.selectedItem.feezeroExBuy = this.selectedData.feezeroExBuy;
      this.selectedItem.feeExShell = this.selectedData.feeExShell;
      this.selectedItem.currencyExShell = this.selectedData.currencyExShell;
      this.selectedItem.typeFeeExShell = this.selectedData.typeFeeExShell;
      this.selectedItem.feezeroExShell = this.selectedData.feezeroExShell;
      this.selectedItem.feeDp = this.selectedData.feeDp;
      this.selectedItem.currencyDp = this.selectedData.currencyDp;
      this.selectedItem.typeFeeDp = this.selectedData.typeFeeDp;
      this.selectedItem.feezeroDp = this.selectedData.feezeroDp;
      this.selectedItem.certificate_title =
          this.selectedData.certificate_title;
      this.selectedItem.certificate_subtitle =
          this.selectedData.certificate_subtitle;
      this.selectedItem.certificate_description =
          this.selectedData.certificate_description;
      this.selectedItem.certificate_footer =
          this.selectedData.certificate_footer;
      this.selectedItem.certificate_watermark =
          this.selectedData.certificate_watermark;
      this.selectedItem.certificate_background =
          this.selectedData.certificate_background;
      this.selectedItem.certificate_question_amount =
          this.selectedData.certificate_question_amount;
      this.selectedItem.certificate_question_year =
          this.selectedData.certificate_question_year;

      this.selectedItem.certificate_ods = this.selectedData.certificate_ods
          ? this.selectedData.certificate_ods.split(',').map((el) => el)
          : [];

      this.selectedItem.category = this.categories.find(cat => Number(cat.id) === Number(this.selectedData.category))
          ? [this.categories.find(cat => Number(cat.id) === Number(this.selectedData.category))]
          : [];


    },
  limpaForm() {
      this.selectedItem = {
        nameToken: null,
        description: null,
        photo: null,
        category: null,
        minValueToken: null,
        totalValueToken: null,
        singleValue: null,
        amountToken: null,
        valueType: null,
        cryptoactive: null,
        certificate: null,
        deadlineToken: null,
        lotes: 1,
        files: [],
      };
    },
    fakeTokensGrid() {
      let letters = Array.from(Array(26), (_, i) =>
        String.fromCharCode(i + 65)
      );
      let z = 1;
      for (let i = 0, j = 0; j < 100; i++, j++) {
        if (i >= letters.length) {
          i = 0;
          z++;
        }
        this.tokens.push(letters[i] + z);
      }
    },
    ...mapMutations(['showSnackbar']),

    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      // this.closeFormModal();

      this.typeValue = null;
      this.selectedItem.nameToken = null;
      this.selectedItem.description = null;
      this.selectedItem.category = null;
      this.selectedItem.amountToken = null;
      this.selectedItem.cryptoactive = null;
      this.selectedItem.certificate = null;
      this.selectedItem.deadlineToken = null;
      this.fixedValue = false;
      this.variableValue = false;
      this.selectedItem.minValueToken = null;
      this.selectedItem.totalValueToken = null;
      this.selectedItem.singleValue = null;
      this.selectedItem.photo = null;
      this.selectedItem.files = [];

      this.filesActives = null;

      this.newLogoToken = 0;

      this.$emit('onClose');
    },

    deleteFile(file, path) {
      this.filesDelete.push(path);
      this.filesActives.splice(file, 1);
    },

    typeValueMounted(value) {
      this.selectedItem.valueType = value;

      if (value === 1) {
        this.fixedValue = true;
        this.variableValue = false;
      } else {
        this.fixedValue = false;
        this.variableValue = true;
      }
    },

    convertBase64: function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    selectedNewLogoToken() {
      this.newLogoToken = 1;
    },

    async handleFiles() {
      this.selectedItem.files = [];

      for (const file of this.files) {
        this.selectedItem.files.push({
          name: file.name,
          data: await this.convertBase64(file),
        });
      }
    },

    async handlePhotos() {
      this.selectedItem.photos = [];

      for (const photo of this.photos) {
        this.selectedItem.photos.push({
          name: photo.name,
          data: await this.convertBase64(photo),
        });
      }
    },

    async loadClientData(query) {
      if (query.length >= 3) {
        this.isLoading = true;

        const params = {
          'filter[nameOrEmail]': query,
        };
        try {
          const {
            data: { data: items },
          } = await ClientsService.get(params);
          this.clientOptions = items;
        } catch {
          this.showSnackbar({
            text: 'Ops! Ocorreu um erro inesperado',
            color: 'error',
          });
        } finally {
          setTimeout(() => (this.isLoading = false), 300);
        }
      }
    },

    async loadCategories() {
      try {
        const [categoriesResponse, subcategoriesResponse] = await Promise.all([
          Api.get('categories'),
          Api.get('subcategories')
        ]);

        this.categories = categoriesResponse.data[0].map((item) => ({
          id: item.id,
          category: item.name,
          adoption: item.adoption,
        }));

        this.subcategoriesList = subcategoriesResponse.data[0].map((item) => ({
          id: item.id,
          subcategory: item.name,
        }));

      } catch (error) {
        this.showSnackbar({
          text: 'Ops!, Houve um erro ao carregar os dados, tente novamente mais tarde.',
          color: 'error',
        });
      }
    },


    async loadTokensGenerate() {
      try {
        const {
          data: { lotes, tokens },
        } = await Api.get(`generation-tokens/${this.selectedIndex}`);
        this.lotes = lotes.map(({ lote }) => lote);
        this.tokensGeral = tokens;
        this.tokens = tokens
          .filter(({ lote }) => lote === 1)
          .map(({ name }) => name);
      } catch {
        this.showSnackbar({
          text: 'Ops!, Houve um erro ao carregar as categorias, tente novamente mais tarde.',
          color: 'error',
        });
      }
    },

    async changeTokens(a) {
      this.tokens = this.tokensGeral
        .filter(({ lote }) => lote === 1)
        .map(({ name }) => name);
    },

    validate() {
      if (
        !this.selectedItem.feeMk ||
        this.selectedItem.currencyMk === null ||
        this.selectedItem.typeFeeMk === null ||
        (!this.selectedItem.feezeroMk && this.selectedItem.feezeroMk !== 0) ||
        // !this.selectedItem.feeSk ||
        // this.selectedItem.currencySk === null||
        // this.selectedItem.typeFeeSk === null||
        // !this.selectedItem.feezeroSk ||

        this.selectedItem.currencyTx === null ||
        this.selectedItem.typeFeeTx === null ||
        // !this.selectedItem.feezeroTx ||

        this.selectedItem.currencyExBuy === null ||
        this.selectedItem.typeFeeExBuy === null ||
        // !this.selectedItem.feezeroExBuy ||
        this.selectedItem.currencyExShell === null ||
        this.selectedItem.typeFeeExShell === null
        // !this.selectedItem.feezeroExShell
        // !this.selectedItem.feeDp ||
        // this.selectedItem.currencyDp === null ||
        // this.selectedItem.typeFeeDp === null ||
        // !this.selectedItem.feezeroDp
      ) {
        this.showSnackbar({
          text: 'Ops! Preencha todas as taxas obrigatórias.',
          color: 'error',
        });
        this.isLoading = false;
        return false;
      }

      if (this.selectedItem.description.length > 250) {
        this.showSnackbar({
          text: 'A descrição deve ter 250 caracteres ou menos.',
          color: 'error',
        });
        this.isLoading = false;
        return false;
      }
      if (!this.selectedItem.deadlineToken) {
        this.showSnackbar({
          text: 'A data limite é obrigatória.',
          color: 'error',
        });
        this.isLoading = false;
        return false;
      }

      if (!this.selectedItem.description) {
        this.showSnackbar({
          text: 'Preencha a descrição da categoria para continuar.',
          color: 'error',
        });
        this.isLoading = false;
        return false;
      }
      return true;
    },

    async submit() {
      this.isLoading = true;
      this.selectedItem.client_id = localStorage.getItem('auth.user_id');

      if (!this.validate()) {
        this.isLoading = false;
        return;
      }

      try {
        if (this.selectedIndex === -1) {
          // Adicionar novo ativo
          await Promise.all(
            this.selectedItem.category.map(async (e) => {
              let data = new FormData();
              data.append('nameToken', this.selectedItem.nameToken);
              data.append('description', this.selectedItem.description);
              data.append('category', e.id);
              data.append('photo', this.selectedItem.photo);
              data.append('minValueToken', this.selectedItem.minValueToken);
              data.append('totalValueToken', this.selectedItem.totalValueToken);
              data.append('amountToken', this.selectedItem.amountToken);
              data.append(
                'cryptoactive',
                this.selectedItem.cryptoactive?.bool || false
              );
              data.append(
                'certificate',
                this.selectedItem.certificate?.bool || false
              );
              data.append('deadlineToken', this.selectedItem.deadlineToken);
              data.append('singleValue', this.selectedItem.singleValue);
              data.append('typeValue', this.selectedItem.valueType);
              data.append('otherUnid', this.selectedItem.otherUnid);
              data.append('complement', this.selectedItem.complement);
              data.append('checkbox', this.checkbox);
              data.append('unidades', this.selectedItem.unidades.unid);
              data.append(
                'valorunidade',
                !this.selectedItem.category.some(({ adoption }) => adoption)
                  ? this.selectedItem.valorunidade
                  : 0
              );

              // Campos do certificado
              data.append(
                'certificate_title',
                this.selectedItem.certificate_title
              );
              data.append(
                'certificate_subtitle',
                this.selectedItem.certificate_subtitle
              );
              data.append(
                'certificate_description',
                this.selectedItem.certificate_description
              );
              data.append(
                'certificate_footer',
                this.selectedItem.certificate_footer
              );
              data.append(
                'certificate_question_amount',
                this.selectedItem.certificate_question_amount
              );
              data.append(
                'certificate_question_year',
                this.selectedItem.certificate_question_year?.bool || false
              );

              let strOds = '';
              if (this.selectedItem?.certificate_ods?.length > 0) {
                strOds = this.selectedItem?.certificate_ods
                  .map((el) => el.id)
                  .join(',');
              }
              data.append('certificate_ods', strOds);

              if (this.selectedItem.certificate_watermark)
                data.append(
                  'certificate_watermark_file',
                  this.selectedItem.certificate_watermark
                );

              if (this.selectedItem.certificate_background)
                data.append(
                  'certificate_background_file',
                  this.selectedItem.certificate_background
                );

              if (this.selectedItem?.subcategories?.length > 0) {
                data.append(
                  'subcategories',
                  JSON.stringify(
                    this.selectedItem.subcategories.map((el) => el.id)
                  )
                );
              } else {
                data.append('subcategories', '[]');
              }

              // Fee
              data.append('feeMk', this.selectedItem.feeMk);
              data.append(
                'currencyMk',
                typeof this.selectedItem.currencyMk == 'boolean'
                  ? this.selectedItem.currencyMk
                  : this.selectedItem.currencyMk?.bool || false
              );
              data.append(
                'typeFeeMk',
                typeof this.selectedItem.typeFeeMk == 'boolean'
                  ? this.selectedItem.typeFeeMk
                  : this.selectedItem.typeFeeMk?.bool || false
              );
              data.append('feezeroMk', this.selectedItem.feezeroMk);

              data.append('feeTx', this.selectedItem.feeTx);
              data.append(
                'currencyTx',
                typeof this.selectedItem.currencyTx == 'boolean'
                  ? this.selectedItem.currencyTx
                  : this.selectedItem.currencyTx?.bool || false
              );
              data.append(
                'typeFeeTx',
                typeof this.selectedItem.typeFeeTx == 'boolean'
                  ? this.selectedItem.typeFeeTx
                  : this.selectedItem.typeFeeTx?.bool || false
              );
              // data.append("feezeroTx", this.selectedItem.feezeroTx);

              data.append('feeExBuy', this.selectedItem.feeExBuy);
              data.append(
                'currencyExBuy',
                typeof this.selectedItem.currencyExBuy == 'boolean'
                  ? this.selectedItem.currencyExBuy
                  : this.selectedItem.currencyExBuy?.bool || false
              );
              data.append(
                'typeFeeExBuy',
                typeof this.selectedItem.typeFeeExBuy == 'boolean'
                  ? this.selectedItem.typeFeeExBuy
                  : this.selectedItem.typeFeeExBuy?.bool || false
              );
              // data.append("feezeroExBuy", this.selectedItem.feezeroExBuy);

              data.append('feeExShell', this.selectedItem.feeExShell);
              data.append(
                'currencyExShell',
                typeof this.selectedItem.currencyExShell == 'boolean'
                  ? this.selectedItem.currencyExShell
                  : this.selectedItem.currencyExShell?.bool || false
              );
              data.append(
                'typeFeeExShell',
                typeof this.selectedItem.typeFeeExShell == 'boolean'
                  ? this.selectedItem.typeFeeExShell
                  : this.selectedItem.typeFeeExShell?.bool || false
              );
              // data.append("feezeroExShell", this.selectedItem.feezeroExShell);

              if (
                this.selectedItem.cryptoactive != null &&
                this.selectedItem.cryptoactive?.bool
              ) {
                data.append('feeDp', this.selectedItem.feeDp);
                data.append(
                  'currencyDp',
                  typeof this.selectedItem.currencyDp == 'boolean'
                    ? this.selectedItem.currencyDp
                    : this.selectedItem.currencyDp?.bool || false
                );
                data.append(
                  'typeFeeDp',
                  typeof this.selectedItem.typeFeeDp == 'boolean'
                    ? this.selectedItem.typeFeeDp
                    : this.selectedItem.typeFeeDp?.bool || false
                );
                // data.append("feezeroDp", this.selectedItem.feezeroDp);

                data.append('feeSk', this.selectedItem.feeSk);
                data.append(
                  'currencySk',
                  typeof this.selectedItem.currencySk == 'boolean'
                    ? this.selectedItem.currencySk
                    : this.selectedItem.currencySk?.bool || false
                );
                data.append(
                  'typeFeeSk',
                  typeof this.selectedItem.typeFeeSk == 'boolean'
                    ? this.selectedItem.typeFeeSk
                    : this.selectedItem.typeFeeSk?.bool || false
                );
                // data.append("feezeroSk", this.selectedItem.feezeroSk);
              }

              this.selectedItem.files.forEach((file, index) =>
                data.append('file' + [index], file)
              );
              data.append('totalFiles', this.selectedItem.files.length);
              data.append('kmz', this.selectedItem.kmz);

              await Api.post('actives', data, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
            })
          );

          this.showSnackbar({
            text: 'Cadastrado! Ativo cadastrado com sucesso.',
            color: 'success',
          });
          this.closeDialog();
        } else {
          // Editar ativo existente
          await Promise.all(
            this.selectedData.arrayDuplicate.map(async (item) => {
              let data = new FormData();
              data.append('nameToken', this.selectedItem.nameToken);
              data.append('description', this.selectedItem.description);
              data.append('category', this.selectedItem.category[0].id);
              data.append('photo', this.selectedItem.photo);
              data.append(
                'minValueToken',
                parseFloat(this.selectedItem.minValueToken)
              );
              data.append(
                'totalValueToken',
                parseFloat(this.selectedItem.totalValueToken)
              );
              data.append('amountToken', this.selectedItem.amountToken);
              data.append('otherUnid', this.selectedItem.otherUnid);
              data.append('complement', this.selectedItem.complement);
              data.append('checkbox', this.checkbox);
              data.append('unidades', this.selectedItem.unidades.unid);
              data.append(
                'valorunidade',
                !this.selectedItem.category?.some(({ adoption }) => adoption)
                  ? this.selectedItem.valorunidade
                  : 0
              );
              if (this.selectedItem.certificate_watermark)
                data.append(
                  'certificate_watermark_file',
                  this.selectedItem.certificate_watermark
                );

              if (this.selectedItem.certificate_background)
                data.append(
                  'certificate_background_file',
                  this.selectedItem.certificate_background
                );
              data.append(
                'subcategories',
                JSON.stringify(
                  this.selectedItem.subcategories.map((el) => el.id)
                )
              );
              data.append(
                'cryptoactive',
                typeof this.selectedItem.cryptoactive == 'boolean'
                  ? this.selectedItem.cryptoactive
                  : this.selectedItem.cryptoactive?.bool || false
              );
              data.append(
                'certificate',
                typeof this.selectedItem.certificate == 'boolean'
                  ? this.selectedItem.certificate
                  : this.selectedItem.certificate?.bool || false
              );
              data.append('deadlineToken', this.selectedItem.deadlineToken);
              data.append('singleValue', this.selectedItem.singleValue);
              data.append('typeValue', this.selectedItem.valueType);

              for (let i = 0; i < this.selectedItem.files.length; i++) {
                data.append('file' + [i], this.selectedItem.files[i]);
              }
              data.append('totalFiles', this.selectedItem.files.length);
              data.append('newLogoToken', this.newLogoToken);
              data.append('filesDelete', this.filesDelete);
              data.append('totalFilesDelete', this.filesDelete.length);

              // Fee
              data.append('feeMk', this.selectedItem.feeMk);
              data.append(
                'currencyMk',
                typeof this.selectedItem.currencyMk == 'boolean'
                  ? this.selectedItem.currencyMk
                  : this.selectedItem.currencyMk?.bool || false
              );
              data.append(
                'typeFeeMk',
                typeof this.selectedItem.typeFeeMk == 'boolean'
                  ? this.selectedItem.typeFeeMk
                  : this.selectedItem.typeFeeMk?.bool || false
              );
              data.append('feezeroMk', this.selectedItem.feezeroMk);

              data.append('feeTx', this.selectedItem.feeTx);
              data.append(
                'currencyTx',
                typeof this.selectedItem.currencyTx == 'boolean'
                  ? this.selectedItem.currencyTx
                  : this.selectedItem.currencyTx?.bool || false
              );
              data.append(
                'typeFeeTx',
                typeof this.selectedItem.typeFeeTx == 'boolean'
                  ? this.selectedItem.typeFeeTx
                  : this.selectedItem.typeFeeTx?.bool || false
              );
              // data.append("feezeroTx", this.selectedItem.feezeroTx);

              data.append('feeExBuy', this.selectedItem.feeExBuy);
              data.append(
                'currencyExBuy',
                typeof this.selectedItem.currencyExBuy == 'boolean'
                  ? this.selectedItem.currencyExBuy
                  : this.selectedItem.currencyExBuy?.bool || false
              );
              data.append(
                'typeFeeExBuy',
                typeof this.selectedItem.typeFeeExBuy == 'boolean'
                  ? this.selectedItem.typeFeeExBuy
                  : this.selectedItem.typeFeeExBuy?.bool || false
              );
              // data.append("feezeroExBuy", this.selectedItem.feezeroExBuy);

              data.append('feeExShell', this.selectedItem.feeExShell);
              data.append(
                'currencyExShell',
                typeof this.selectedItem.currencyExShell == 'boolean'
                  ? this.selectedItem.currencyExShell
                  : this.selectedItem.currencyExShell?.bool || false
              );
              data.append(
                'typeFeeExShell',
                typeof this.selectedItem.typeFeeExShell == 'boolean'
                  ? this.selectedItem.typeFeeExShell
                  : this.selectedItem.typeFeeExShell?.bool || false
              );
              // data.append("feezeroExShell", this.selectedItem.feezeroExShell);

              if (
                (this.selectedItem.cryptoactive != null &&
                  this.selectedItem.cryptoactive?.bool) ||
                false
              ) {
                data.append('feeDp', this.selectedItem.feeDp);
                data.append(
                  'currencyDp',
                  typeof this.selectedItem.currencyDp == 'boolean'
                    ? this.selectedItem.currencyDp
                    : this.selectedItem.currencyDp?.bool || false
                );
                data.append(
                  'typeFeeDp',
                  typeof this.selectedItem.typeFeeDp == 'boolean'
                    ? this.selectedItem.typeFeeDp
                    : this.selectedItem.typeFeeDp?.bool || false
                );
                // data.append("feezeroDp", this.selectedItem.feezeroDp);

                data.append('feeSk', this.selectedItem.feeSk);
                data.append(
                  'currencySk',
                  typeof this.selectedItem.currencySk == 'boolean'
                    ? this.selectedItem.currencySk
                    : this.selectedItem.currencySk?.bool || false
                );
                data.append(
                  'typeFeeSk',
                  typeof this.selectedItem.typeFeeSk == 'boolean'
                    ? this.selectedItem.typeFeeSk
                    : this.selectedItem.typeFeeSk?.bool || false
                );
                // data.append("feezeroSk", this.selectedItem.feezeroSk);
              }

              data.append('kmz', this.selectedItem.kmz);

              await Api.post(`actives/edit/${item.code}`, data, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
            })
          );

          this.showSnackbar({
            text: 'Editado! Ativo editado com sucesso.',
            color: 'success',
          });
          this.closeDialog();
        }
      } catch (error) {
        console.error('Erro ao cadastrar/editar ativo:', error);
        this.showSnackbar({
          text: 'Ops! Houve um erro, tente novamente.',
          color: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style>
#tokens {
  padding: 0;
  margin: 0;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  gap: 7px;
}
#tokens li {
  text-align: center;
  min-width: 30px;
  list-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 3px;
}
#tokens2 {
  padding: 0;
  margin: 0;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  gap: 10px;
}
#tokens2 li {
  text-align: center;
  list-style: none;
  padding: 5px;
  padding-left: 2px;
  min-width: 35px;
}
</style>
